import { useSessionFile } from '../../shared/hooks/session-file-hook';
import { sessionKey } from '../../shared/util/session-storage';
import PageHeading from '../../shared/components/UIElements/PageHeading';
import EmptyState from '../../shared/components/UIElements/EmptyState';
import Icon from '../../shared/components/UIElements/Icon';
import './Reports.css';
import React, { useState, useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { AuthContext } from '../../shared/Context/auth-context';
import { useHttpClient } from '../../shared/hooks/http-hook';
import Button from '../../shared/components/FormElements/Button';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import ErrorModal from '../../shared/components/UIElements/ErrorModal';
import { BACKEND_URL } from '../../shared/util/backend-url';

let userId, userType;
const Reports = () => {
  const { patientId } = useParams();
  const auth = useContext(AuthContext);
  const { sendRequest, isLoading, error, clearError } = useHttpClient();

  const scope = auth.doctor ? `doctor:${auth.doctor._id}` : `patient:${auth.patient?._id}`;
  const [selectedFile, setSelectedFile, fileStatus] = useSessionFile(
    sessionKey(scope, `report:${patientId}:file`)
  );
  const [previewUrl, setPreviewUrl] = useState(null);
  const [recentReports, setRecentReports] = useState([]);

  useEffect(() => {
    const fetchReports = async () => {
      //const patientId = auth.patient?._id || auth.selectedPatientId;
      if (!patientId) return;

      try {
        const responseData = await sendRequest(
          `${BACKEND_URL}/api/reports/last/${patientId}`,
          'GET',
          null,
          { Authorization: 'Bearer ' + auth.token }
        );
        setRecentReports(responseData.reports);
      } catch (err) {
        console.error(err);
      }
    };

    fetchReports();
  }, [patientId, sendRequest, auth.token]);

  useEffect(() => {
    if (!selectedFile?.type.startsWith('image/')) {
      setPreviewUrl(null);
      return;
    }
    const reader = new FileReader();
    reader.onload = () => setPreviewUrl(reader.result);
    reader.readAsDataURL(selectedFile);
    return () => {
      if (reader.readyState === 1) reader.abort();
    };
  }, [selectedFile]);

  const fileChangeHandler = (event) => {
    const file = event.target.files[0];
    if (file) setSelectedFile(file);
  };
  const uploadHandler = async (event) => {
    event.preventDefault();
    if (!selectedFile) return;

    //let patientId;

    if (auth.doctor) {
      userId = auth.doctor._id;
      userType = 'Doctor';
      //patientId = auth.selectedPatientId;
    } else if (auth.patient) {
      userId = auth.patient._id;
      userType = 'Patient';
      //patientId = auth.patient._id;
    } else {
      alert('Not logged in');
      return;
    }

    try {
      const formData = new FormData();
      formData.append('report', selectedFile);
      formData.append('uploadedBy', userId);
      formData.append('userType', userType); // "doctor" or "patient"
      formData.append('patientId', patientId);

      await sendRequest(`${BACKEND_URL}/api/reports/upload`, 'POST', formData, {
        Authorization: 'Bearer ' + auth.token
      });

      alert('Report uploaded successfully!');
      setSelectedFile(null);
      setPreviewUrl(null);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <ErrorModal error={error} onClear={clearError} />
      <div className="reports-page">
        <PageHeading
          eyebrow="HEALTH RECORDS"
          title="Health reports"
          description="Keep test results and medical documents together for your next consultation."
        />
        <div className="reports-layout">
          <form onSubmit={uploadHandler} className="report-form">
            {isLoading && <LoadingSpinner asOverlay />}
            <div className="panel-heading">
              <h2>Upload a report</h2>
              <Icon name="upload" />
            </div>
            <div className="report-upload">
              <span className="empty-state__icon">
                <Icon name="upload" size={28} />
              </span>
              <label htmlFor="report-file">Choose a medical report</label>
              <p>PDF or image files</p>
              <input
                id="report-file"
                type="file"
                accept=".pdf,image/*"
                onChange={fileChangeHandler}
              />
            </div>
            {previewUrl && (
              <div className="report-preview">
                <img src={previewUrl} alt="Selected report preview" />
              </div>
            )}
            {!previewUrl && selectedFile?.type === 'application/pdf' && (
              <p className="selected-file">
                <Icon name="file" size={18} />
                {selectedFile.name}
              </p>
            )}
            {selectedFile && (
              <p
                className={`session-save-note ${fileStatus === 'unavailable' ? 'session-save-note--error' : ''}`}
                role="status"
              >
                {fileStatus === 'saving'
                  ? 'Keeping this file in the current tab…'
                  : fileStatus === 'unavailable'
                    ? 'This file could not fit in tab storage. You can upload it now, or reselect it after leaving this page.'
                    : `Selected: ${selectedFile.name}. This file is kept in the current tab.`}
              </p>
            )}
            <Button type="submit" disabled={!selectedFile}>
              <Icon name="upload" size={17} /> Upload report
            </Button>
          </form>
          <section className="recent-reports">
            <div className="panel-heading">
              <div>
                <h2>Recent reports</h2>
                <p>Your two most recent uploads.</p>
              </div>
              <Icon name="file" />
            </div>
            {recentReports.length === 0 && !isLoading && (
              <EmptyState title="No recent reports">Uploaded reports will appear here.</EmptyState>
            )}
            {recentReports.map((report, index) => (
              <div className="report-row" key={report._id}>
                <span className="summary-icon">
                  <Icon name="file" />
                </span>
                <div>
                  <h3>Medical report {index + 1}</h3>
                  <p>Uploaded by {report.userType}</p>
                </div>
                <a
                  href={`${BACKEND_URL}/${report.fileUrl}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  View report <Icon name="arrow" size={16} />
                </a>
              </div>
            ))}
          </section>
        </div>
      </div>
    </>
  );
};
export default Reports;
